import InstructionsCheckbox from 'components/Input/InstructionsCheckboxInput';
import InstructionBox from 'components/Instruction/InstructionBox';
import { InstructionCallout } from 'components/Instruction/InstructionCallout';
import InstructionItem from 'components/Instruction/InstructionItem';
import { AppLink } from 'components/Link/AppLink';
import COLORS from 'constants/colors';
import { useAutoScrollInstructions } from 'hooks/useAutoScrollInstructions';
import styled from 'styled-components';
import MainContainer from '../../SignInMainContainer';

interface ActivateSecurityPolicyProps {
  activateSecurityConfirmed: {
    value: string;
    invalid: boolean;
    onChange: (value: string, invalid?: boolean) => void;
  };
  instructionsLink?: string;
  instructionsInnerHtmlToScroll?: string;
}

const StyledInstructionBox = styled(InstructionBox)`
  margin-bottom: 12px;
`;

const ActivateSecurityPolicy = ({
  activateSecurityConfirmed,
  instructionsLink,
  instructionsInnerHtmlToScroll,
}: ActivateSecurityPolicyProps) => {
  useAutoScrollInstructions(instructionsLink, instructionsInnerHtmlToScroll);

  return (
    <>
      {instructionsLink && (
        <>
          <InstructionCallout
            link={instructionsLink}
            innerHtmlToScroll={instructionsInnerHtmlToScroll}
          >
            Open{' '}
            <AppLink
              href={instructionsLink}
              rel="noreferrer"
              target="_blank"
              showInFrame
              innerHtmlToScroll={instructionsInnerHtmlToScroll}
            >
              this guide
            </AppLink>{' '}
            to complete the steps below. Then click Continue.
          </InstructionCallout>
          <StyledInstructionBox>
            <InstructionItem index={1} badgeColor={COLORS.GRAY.GRAY_600}>
              In the search bar at the top of the page, search for
              &quot;Activate Pending Security Policy Changes&quot; and click on
              the resulting task
            </InstructionItem>
            <InstructionItem index={2} badgeColor={COLORS.GRAY.GRAY_600}>
              Activate the pending Security Policy changes
            </InstructionItem>
          </StyledInstructionBox>
        </>
      )}
      <MainContainer useNewDesign>
        <InstructionsCheckbox
          label="I've completed these steps"
          checked={activateSecurityConfirmed.value === 'true'}
          onChange={(checked) =>
            activateSecurityConfirmed.onChange(checked ? 'true' : '')
          }
        />
      </MainContainer>
    </>
  );
};

export default ActivateSecurityPolicy;
